import React from 'react';
import { cx } from '@emotion/css';
import * as styles from '../Class/batches.style.js';
// import "./batches.css";
import Amplify, { Auth } from 'aws-amplify';
import EditBatchIcon from '../../assets/images/edit-batch.png';
import MailIcon from '../../assets/images/email.png';
import { Hint } from 'react-autocomplete-hint';
import Select from 'react-select';
import { selectMedium } from '../../styles/components/forms.style';
import './FeedBackPopup.css'; // New import for CSS

function FeedBackPopup(props) {
    const [feedback, setFeedback] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [status, setStatus] = React.useState('Send Feedback');
    const [sending, setSending] = React.useState(false); // NEW
    const categorytypes = [
        'Wrong Meaning',
        'Wrong Example',
        'Wrong Answer',
        'Question not clear',

    ];
    const [checks, setChecks] = React.useState('');

    const getToken = async () => {
        setSending(true); // NEW
        Auth.currentSession().then((res) => {
            //console.log("Auth.currentSession()")
            let accessToken = res.getAccessToken();
            ////console.log("accessToken called ")
            let jwt = accessToken.getJwtToken();
            ////console.log("Got jwt ")
            let useremail = Auth.user.attributes.email;
            ////console.log(useremail)
            sendFeedBack(Auth.user.username, useremail, jwt);



        });
    };

    const sendFeedBack = async (username, useremail, jwt) => {
        const id = Date.now();

        setStatus('Sending Feedback...');
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: jwt },

            body: JSON.stringify({
                sender: "admin@quizwizard.net",
                recipient: "mathforminds@gmail.com",
                username: username,
                email: useremail,
                question: props["presentquestion"],
                feedback: feedback,
                category: props["eventname"]
            }),
        };
        ////console.log(requestOptions)
        await fetch(
            `https://api.dev.quizwizard.net/quiz/sendemail`,
            requestOptions
        );
        // const data = await response.json();
        // console.log(data)
        // console.log(props["presentquestion"].id)
        // console.log(props["presentquestion"].question)
        setSending(false); // NEW
        props.selected();

    };

    function createbatch() {
        getToken();
    }

    return (
        <div className="mypopup-box">
            <div className="mybox" style={{ width: 500, minWidth: 220, padding: '18px 16px 14px 16px' }}>
                <button className="close-icon" onClick={props.handleClose} disabled={sending}>
                    ×
                </button>
                <div className="editBatchesMain">
                    <img src={MailIcon} alt="Feedback" style={{ width: 36, marginBottom: 6 }} />
                    <h3 style={{ fontSize: '1.05rem', marginBottom: 10 }}>Share Your Feedback</h3>
                    <input
                        name="feedback"
                        type="text"
                        spellCheck="false"
                        autoComplete="off"
                        value={feedback}
                        onChange={(e) => setFeedback(e.target.value)}
                        placeholder="What would you like to tell us?"
                        required
                        style={{ width: '90%', fontSize: '0.92rem', padding: '5px 8px' }}
                        disabled={sending}
                    />
                    <Select
                        name="category"
                        className={selectMedium}
                        classNamePrefix="select"
                        value={category.length ? { label: category, value: category } : null}
                        placeholder="Select a category"
                        onChange={(e) => setCategory(e.value)}
                        options={categorytypes.map((questiontype) => ({
                            label: questiontype,
                            value: questiontype,
                        }))}
                        isSearchable={false}
                        isDisabled={sending}
                        styles={{
                            control: (base) => ({
                                ...base,
                                minHeight: 28,
                                fontSize: '0.92rem',
                                borderRadius: 8,
                            }),
                            menu: (base) => ({
                                ...base,
                                fontSize: '0.92rem',
                            }),
                        }}
                    />
                    {sending && (
                        <div style={{ width: '90%', margin: '10px 0' }}>
                            <div style={{
                                width: '100%',
                                height: 6,
                                background: '#ffe0cc',
                                borderRadius: 4,
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    width: '100%',
                                    height: '100%',
                                    background: 'linear-gradient(90deg, #ff6600 0%, #ff9900 100%)',
                                    animation: 'progressBarAnim 1s linear infinite'
                                }} />
                            </div>
                        </div>
                    )}
                    <button
                        className="createeventbutton"
                        onClick={createbatch}
                        disabled={!feedback.trim() || !category || sending}
                        style={{ fontSize: '0.92rem', padding: '6px 16px', marginTop: 8 }}
                    >
                        {sending ? 'Sending...' : 'Send'}
                    </button>
                </div>
            </div>
            <style>
                {`
                @keyframes progressBarAnim {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
                `}
            </style>
        </div>
    );
}

export default FeedBackPopup;
